/* Consent types + storage contract.
 *
 * Plan §"Cookie Consent & Session Preference":
 *   - categories: Necessary (always), Functional, Analytics, Marketing,
 *   - `Pamatuj si mě` (login persistence) requires Functional consent,
 *   - persisted via `localStorage` + per-tenant key,
 *   - audit record: consent version + timestamp + accepted categories.
 */

import { CONSENT_VERSION } from '../../shared/consent/constants.js';

export type ConsentCategory = 'necessary' | 'functional' | 'analytics' | 'marketing';

export interface ConsentDecision {
  /** Necessary is always true and non-editable; serialized for explicit audit. */
  necessary: true;
  functional: boolean;
  analytics: boolean;
  marketing: boolean;
  profiling: boolean;
  version: string;
  decidedAtMs: number;
}

export const DEFAULT_DECISION: Omit<ConsentDecision, 'decidedAtMs' | 'version'> = {
  necessary: true,
  functional: false,
  analytics: false,
  marketing: false,
  profiling: false,
};

export function buildAcceptAll(
  nowMs: number,
  opts?: { loyaltyProfilingAvailable?: boolean }
): ConsentDecision {
  return {
    necessary: true,
    functional: true,
    analytics: true,
    marketing: true,
    profiling: opts?.loyaltyProfilingAvailable === true,
    version: CONSENT_VERSION,
    decidedAtMs: nowMs,
  };
}

export function buildAcceptNecessary(nowMs: number): ConsentDecision {
  return {
    necessary: true,
    functional: false,
    analytics: false,
    marketing: false,
    profiling: false,
    version: CONSENT_VERSION,
    decidedAtMs: nowMs,
  };
}

export function buildAcceptSelection(
  selection: {
    functional: boolean;
    analytics: boolean;
    marketing: boolean;
    profiling?: boolean;
  },
  nowMs: number
): ConsentDecision {
  return {
    necessary: true,
    functional: selection.functional,
    analytics: selection.analytics,
    marketing: selection.marketing,
    profiling: selection.profiling === true,
    version: CONSENT_VERSION,
    decidedAtMs: nowMs,
  };
}
